import HotelResultCard from '../components/results/HotelResultCard';
import SearchResultsLayout from '../components/SearchResultsLayout';
import { SEARCH_BANNERS } from '../data/mockData';

export default function HotelResultsPage() {
  return (
    <SearchResultsLayout
      type="hotels"
      bannerImage={SEARCH_BANNERS.hotels}
      title="Hotel Search Results"
      summary={(sp) =>
        `${sp.get('destination') || 'Any city'} · ${sp.get('checkIn') || '—'} to ${sp.get('checkOut') || '—'}`
      }
      renderCard={(item, searchParams) => (
        <HotelResultCard key={item.id} item={item} searchParams={searchParams} />
      )}
    />
  );
}
